/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Onedata_Append_Row_LabelInputs */



/**
* | output |
* | --- |
* | "The row to append to the agent's dataset table" |
*
* @param {Chat_Onedata_Append_Row_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_append_row_label = /** @type {((inputs?: Chat_Onedata_Append_Row_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Append_Row_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zeile, die an die Datensatztabelle des Agenten angehängt wird")
	return /** @type {LocalizedString} */ ("The row to append to the agent's dataset table")
});